import { requireStringField, requireMinorAmountField, optionalMinorAmountField, optionalStringField } from "./ReplayPayloadValidation";
  
  export type ParsedPresentBigWinPayload = {
    levelIdentifier: string;
    spinWinAmount: string;
    betAmount?: string;
    winRatioLabel?: string;
  };
  
  export function parsePresentBigWinPayload(
    actionTypeName: string,
    payload: Record<string, unknown>
  ): ParsedPresentBigWinPayload {
    const levelIdentifier = requireStringField(actionTypeName, payload, "levelIdentifier");
    // Whole minor units, like every amount the game turns into money (2026-09-26): until then any
    // text passed, and the big-win panel counted up to 0 for a malformed one.
    const spinWinAmount = requireMinorAmountField(actionTypeName, payload, "spinWinAmount");
    const betAmount = optionalMinorAmountField(actionTypeName, payload, "betAmount");
    const winRatioLabel = optionalStringField(payload, "winRatioLabel");
  
    return { levelIdentifier, spinWinAmount, betAmount, winRatioLabel };
  }